"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_0_1 = void 0;
exports.migration_0_1 = {
    version: "0.1",
    from: "",
    migrate: function (state) { },
};
//# sourceMappingURL=migration_0_1.js.map